// Environment
const isProduction: boolean = window.location.hostname === "dashboard.statratapp.com";

// API Base URL
export const baseURL: string = isProduction ? "https://servicedashboard.statratapp.com/" : "https://testservicedashboard.statratapp.com/";

// Stripe API Key
export const stripeKey: string = process.env.REACT_APP_STRIPE_PUBLIC_KEY ?? "pk_test_A7jK4iCYHL045qgjjfzAfPxu";

// Colors
export const statratRed: string = '#E20033';
export const statratBlack: string = '#2B2B2B';
export const statratGray: string = '#F0F0F0';

// Drawer Width
export const drawerWidth: number = 240;

// Objective Options
export const objectives: { [key: number]: string } = {
    0: "All Pages",
    1: "Home Page",
    2: "Explore Page",
}

// Demographics Options
export const countriesWithProvinces: string[] = ["CA", "DO"];

export const countryList: { value: string, label: string }[] = [
    { value: "CA", label: "Canada - CA" },
    { value: "US", label: "United States - US" },
    { value: "VE", label: "Venezuela - VE" },
    { value: "MX", label: "Mexico - MX" },
    { value: "DO", label: "Dominican Republic - DO" },
]

// Profile Customization Options
export const positionList: string[] = [
    "Pitcher", "Catcher", "1st Base", "2nd Base", "3rd Base", "Shortstop", "Left Field", 
    "Center Field", "Right Field"
];
export const batBrandList: string[] = [
    "Akadema", "Birdman", "Chandler", "Demarini", "Easton", "Louisville Slugger", "Marucci",
    "Mattingly", "Mizuno", "Prairie Sticks", "Rawlings", "Sabre", "Sam", "Tater", "Victus",
    "Viper", "Warstic", "Other"
];
export const gloveBrandList: string[] = [
    "All Star", "Akadema", "Easton", "Franklin", "Louisville Slugger", "Marucci", "Mizuno",
    "Nokona", "Rawlings", "Rival", "Shoeless Joe", "Wilson", "44 Pro", "Other"
];
export const cleatBrandList: string[] = [
    "Adidas", "New Balance", "Nike", "Under Armour", "Other"
];
export const battingGloveBrandList: string[] = [
    "A2000", "Bruce Bolt", "Easton", "Franklin Sports", "Louisville Slugger", "Marucci",
    "Mizuno", "Nike", "Rawlings", "Rival", "Under Armour", "Wilson", "Worth", "Other"
];
